export default class GetDftConnectivityToolScoreViewModel {
    squareId: string | null = '';
    connectivityScore: number | null = null;
    drivingConnectivityScore: number | null = null;
    localAuthorityName: string | null = '';
    localAuthorityBand: string | null = '';
    walkingConnectivityScore: number | null = null;
    cyclingConnectivityScore: number | null = null;
    publicTransportConnectivityScore: number | null = null;
    residentialDevelopmentsScore: number | null = null;
    educationDevelopmentsScore: number | null = null;
    leisureDevelopmentsScore: number | null = null;
    healthDevelopmentsScore: number | null = null;
    shoppingDevelopmentsScore: number | null = null;
    workplaceDevelopmentsScore: number | null = null;
}
